<template>
  <div class="page page-error">
    <Header />

    <h1 class="page-title">Page Not Found</h1>

    <GridHelper />
  </div>
</template>

<script>
import Header from '../components/Header.vue'

export default {
  name: 'PageNotFound',
  components: {
    Header,
  },
  mounted () {
    document.body.classList.add('page-template-404')
  },
  beforeUnmount () {
    document.body.classList.remove('page-template-404')
  }
}
</script>

<style scoped>
  .page-title {
    display: block;
    position: absolute;
    top: 50vh;
    transform: translateY(-50%);
    font-family: "Gotham Book";
    font-size: 40px;
    padding: 0 30px 100px;
    text-align: center;
    width: 100%;
    text-transform: uppercase;
  }
</style>